export type DayNightPhase = "day" | "dusk" | "night" | "dawn";

export const DAY_NIGHT_PHASES: readonly DayNightPhase[] = [
  "day",
  "dusk",
  "night",
  "dawn",
] as const;
